/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ChangeRequestReview, ChangeRequestReviewStatus, Document, List } from "./data-contracts";

/**
 * No description
 * @tags change-requests-reviews
 * @name GetReviewsByChangeRequestId
 * @summary List all change request reviews
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews
 * @secure
 */

// @ts-ignore
export const getReviewsByChangeRequestId: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /** Filter reviews marked as outdated. */
    outdated?: boolean;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequestReview[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews",
  method: "get",
  streaming: false,
  tags: ["change-requests-reviews"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests-reviews
 * @name SubmitChangeRequestReview
 * @summary Submit a change request review
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/reviews
 * @secure
 */

// @ts-ignore
export const submitChangeRequestReview: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The status of the submitted review. */
    status: ChangeRequestReviewStatus;
    /** Optionally, provide a comment along with the review. */
    comment?: Document;
  };
  RequestHeaders: {};
  ResponseBody: ChangeRequestReview;
  ResponseStatusCode: 201;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/reviews",
  method: "post",
  streaming: false,
  tags: ["change-requests-reviews"],
  criticalityLevel: "low",
  deprecated: false,
};
